<template>
  <b-container class="p-0">
    <b-card>
      <b-row class="transaction-container">
        <b-col
          xl="auto"
          lg="12"
          md="12"
          cols="12"
          class="transaction-info-container"
        >
          <p>
            {{ transactionDate }}
          </p>
          <p class="price-text left">
            {{ valueInReal }}
          </p>
        </b-col>
        <b-col
          v-if="cardData"
          xl="auto"
          lg="6"
          md="6"
          sm="6"
          cols="6"
          class="card-container"
        >
          <b-img
            :src="cardBrandSrc"
            class="mt-2"
          />
          <p class="mt-2">{{ cardData.text }}<br>
            {{ data.payment.installments === 1 ? 'Á vista' : 'Parcelado' }}
          </p>
        </b-col>

        <b-col
          xl="auto"
          :lg="cardData ? 6 : 12"
          :md="cardData ? 6 : 12"
          :sm="cardData ? 6 : 12"
          :cols="cardData ? 6 : 12"
        >
          <div
            class="status-container"
            :class="`${data.link.status === 11 || data.link.status === 2 ? 'status-waiting' : ''}`"
          >
            <feather-icon
              size="40"
              class="status-item"
              :icon="status.icon"
              :style="`color: ${status.color} !important;`"
            />
            <b-alert
              class="status-item"
              :variant="status.variant"
              show
            >
              {{ status.status }}
            </b-alert>
          </div>
        </b-col>
      </b-row>

      <b-row class="customer-container mt-1 ">
        <b-col
          sm="6"
          lg="6"
          :xl=" data.customer.name.length < 18 ? 3 : 'auto'"
        >
          <h6>Nome:</h6>
          <p class="mt-1">
            {{ data.customer.name }}
          </p>
        </b-col>
        <b-col
          sm="6"
          lg="6"
          xl="auto"
        >
          <h6>Email:</h6>
          <p class="mt-1">
            {{ data.customer.email }}
          </p>
        </b-col>
        <b-col
          v-if="data.customer.tax_id"
          sm="6"
          lg="6"
          xl="auto"
        >
          <h6>{{ data.customer.tax_id.length === 14 ? 'CPF' : data.customer.tax_id.length === 18 ? 'CNPJ' : 'Documento' }}:</h6>
          <p class="mt-1">
            {{ data.customer.tax_id }}
          </p>
        </b-col>
        <b-col
          class=""
          sm="6"
          lg="6"
          xl="12"
        >
          <h6
            class="field-left"
          >
            Estabelecimento:
          </h6>
          <p
            class="mt-1 establishment-text"
          >
            {{ data.user.merchant_name || data.user.name }}
          </p>
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
import {
  BCard,
  BContainer,
  BAlert,
  BRow,
  BCol,
  BImg,
} from 'bootstrap-vue'

import { DateTime } from 'luxon'
import FeatherIcon from '../../../@core/components/feather-icon/FeatherIcon.vue'

const { daysWeek, cardBrandIcon, statusObject } = require('@/information/detailsTransaction')

export default {
  components: {
    BAlert,
    BCard,
    BContainer,
    BRow,
    BCol,
    BImg,
    FeatherIcon,
  },
  props: ['data'],
  data() {
    return {
      cardData: {},
      status: {},
    }
  },

  computed: {
    transactionDate() {
      const { created_at } = this.data.link
      const { transaction_date } = this.data.payment
      const year = transaction_date ? DateTime.fromISO(transaction_date).year : 1970
      const date = year !== 1970 ? transaction_date : created_at

      const weekdayTransaction = daysWeek[DateTime.fromISO(date).weekday]

      const transactionDate = DateTime.fromISO(date).toFormat('dd/MM/yyyy')
      const transactionHours = `${DateTime.fromISO(date).toFormat('HH')}h${DateTime.fromISO(date).toFormat('mm')}`

      return transactionDate.concat(', ', weekdayTransaction, ', ', transactionHours)
    },

    valueInReal() {
      const formatter = new Intl.NumberFormat('pt-br', {
        style: 'currency',
        currency: 'BRL',
      })
      const { value } = this.data.payment
      return formatter.format(value)
    },

    cardBrandSrc() {
      const { image } = this.cardData
      return require(`@/assets/images/paymentIcons/${image}`)
    },
  },

  created() {
    this.handleCardBrand()
    this.handleStatus()
  },

  methods: {
    handleCardBrand() {
      this.cardData = cardBrandIcon[this.data.payment.card_brand]
    },

    handleStatus() {
      this.status = statusObject[this.data.link.status]
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "@core/scss/base/components/info-card.scss";
</style>
